import { render, staticRenderFns } from "./CampaignDataViewer.vue?vue&type=template&id=4299898a&"
import script from "./CampaignDataViewer.vue?vue&type=script&lang=js&"
export * from "./CampaignDataViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports